import {StorageUtility} from './Storage';
import {URLManager} from './URLManager';
import {UI} from './UI';
import {Locale} from './Locale';

declare var $: any;
declare var window: any;
declare var DataLayer: any;

export class Affiliate {
    private static instance: Affiliate;

    static getInstance() {
        if (!Affiliate.instance) {
            Affiliate.instance = new Affiliate();
        }
        return Affiliate.instance;
    }

    pages: object;
    exeptionPageNoTrackingWithoutParam: object;

    private constructor() {
        this.pages = {
            '30off.html': 'LP30OFF',
            'affiliate/keeper-30OFFDeals.html': 'KP30A',
            'affiliate/keeper-30OFFDealsTS.html': 'KP30A',
            'affiliate/keeper-30OFFDealsCN.html': 'KP30A',
            'affiliate/keeper-30OFFTop10.html': 'KP30A',
            'affiliate/keeper-30OFFCV.html': 'KP30A',
            'affiliate/keeper-PCMag30OFF.html': 'KP30A',
            'new-year-resolution.html': 'KP30A',
            'affiliate/keeper-mashable30OFF.html': 'KP30A',
            'affiliate/30discount-keeper-unlimited.html': 'KP30A',
            'affiliate/family-17off-special.html': 'FAMILY17KEEP',
            'affiliate/keeper-15off-unlimited.html':
                URLManager.getInstance().getParams()['instapage-promo'] || 'KEEPER15A',
            'affiliate/keeper-15off-unlimited-tr.html':
                URLManager.getInstance().getParams()['instapage-promo'] || 'KEEPER15A',
            'affiliate/keeper-17off-family.html': 'FAMILY17KEEP',
            'multiyear-affiliate.html': 'KP10K',
            'multiyear-affiliate-tr.html': 'KP10K',
            'multiyear-affiliate-v2.html': 'KP20P',
            'affiliate/w3yearplans.html': 'KP10K',
            'affiliate/b3yearplans.html': 'KP10K',
            'affiliate/keeper-10off-unlimited.html': 'KP10K',
            'specialoffer-save30.html': 'KP10K',
            'special-offer-winter30.html': 'WINTERBEN30',
            'affiliate/keeper-20off-unlimited.html': 'KP20P',
            'newdevices.html': 'NEWDEVICE',
            'credit-union-20OFFDeals.html': URLManager.getInstance().getParams()['cu-promo'] || '',
            'affiliate/cam.html': 'KP30A',
            'affiliate/keeper-25off-unlimited.html': 'KPS25T',
            'affiliate/keeper-30off-unlimited.html': 'KP30A',
            'affiliate/keeper-30OFFSD.html': 'KP30A',
            'affiliate/keeper-35off-unlimited.html': 'KPS35G',
            'affiliate/keeper-40off-unlimited.html': 'KPS40Y',
            'affiliate/keeper-40offCN-unlimited.html': 'KPS40Y',
            'affiliate/keeper-50off-unlimited.html': 'KPS50A',
            'affiliate/40OFF.html': 'KPS40M',
            'affiliate/LM40OFF.html': 'KPS40Y',
            'affiliate/50OFF.html': 'KPS50A',
            'spring50off.html': 'KPS50A',
            'holiday50.html': 'KPS50A',
            'summer50.html': 'KPS50A',
            'affiliate/keeper.html':
                URLManager.getInstance().getParams()['instapage-promo'] || 'KEEPER15A',
            'affiliate/paid-media-15off-unlimited.html': 'KEEPER15A',
        };

        this.exeptionPageNoTrackingWithoutParam = {
            'spring50off.html': true,
        };

        UI.getInstance().domReady(() => {
            if (this.isExceptionTrackingPage() && !this.isAffiliate()) {
                StorageUtility.getInstance().removeLocal('affiliate');
                return;
            }
            this.createTrackingToken();
            this.tokenizePurchaseLinks();
        });
    }

    //////////////////////////////////////////

    public isExceptionTrackingPage() {
        let pageName = window.location.pathname.substr(1);

        // if non-US locale
        if (Locale.getInstance().getCurrentLocale() !== 'en_US') {
            pageName = window.location.pathname.substr(7);
        }

        return !!this.exeptionPageNoTrackingWithoutParam[pageName];
    }

    //////////////////////////////////////////

    public createTrackingToken() {
        let pageName = window.location.pathname.substr(1);

        // if non-US locale
        if (Locale.getInstance().getCurrentLocale() !== 'en_US') {
            pageName = window.location.pathname.substr(7);
        }

        const promoCode = this.pages[pageName] || '';
        this.createAffiliateToken(promoCode || '');
    }

    //////////////////////////////////////////

    public tokenizePurchaseLinks() {
        this.rakutenTokenizeLinks();
    }

    //////////////////////////////////////////

    public isAffiliate() {
        const params = URLManager.getInstance().getParams();
        return params['ranSiteID'] || params['cjevent'] || params['irclickid'] || params['ps_xid']
            ? true
            : false;
    }

    //////////////////////////////////////////

    public hasAffiliateToken() {
        return StorageUtility.getInstance().getLocal('affiliate') ? true : false;
    }

    //////////////////////////////////////////

    public isB2BTrialOffer(idToCompare) {
        return true;
    }

    //////////////////////////////////////////

    public hasAlreadyTriggeredPixel = function () {
        if (this.hasAffiliateToken()) {
            if (this.isTokenExpired()) {
                // this conditional prevents reporting to BI when token expired
                return true;
            }
            const token = JSON.parse(StorageUtility.getInstance().getLocal('affiliate') || '{}');
            if (token.leadPixelTriggered === true) {
                return true;
            }
        }
        return false;
    };

    //////////////////////////////////////////

    public hasTrialOrderID() {
        const params = URLManager.getInstance().getParams();
        if (this.hasAffiliateToken()) {
            const token = JSON.parse(StorageUtility.getInstance().getLocal('affiliate') || '{}');
            return token && this.isB2BTrialOffer(token.puboffer);
        } else if (this.isAffiliate()) {
            return this.isB2BTrialOffer(params['puboffer']);
        }
        return false;
    }

    //////////////////////////////////////////

    public affiliateConversion(orderID, email, conversionType = 'B2B') {
        this.tryAffiliateConversion(orderID, false, email, conversionType);
    }

    //////////////////////////////////////////////////////////////////

    public rakutenTokenizeLinks() {
        // Safety check to ensure jQuery is available
        if (typeof $ === 'undefined') {
            console.warn('jQuery library not available yet');
            return;
        }

        const token = StorageUtility.getInstance().getLocal('affiliate');
        let count = 0;
        if (!token) return;
        $('a').each((index, item) => {
            const link = $('a')[index];
            let href = $(link).attr('href');
            if (href && href.indexOf('checkout') !== -1) {
                count++;
                href.indexOf('?') > 0
                    ? (href += '&affiliate_token=' + token)
                    : (href += '?affiliate_token=' + token);
                $(link).attr('href', encodeURI(href));
            }
        });
        if (count > 0)
            console.debug(
                '%cAll ' + count + ' purchase link(s) have been tokenized with Rakuten.',
                'color: green;'
            );
    }

    //////////////////////////////////////////////////////////////////

    public rakutenGetTimestamp() {
        const year = String(new Date().getUTCFullYear());

        let month = String(new Date().getUTCMonth() + 1);
        if (month.length == 1) month = '0' + month;

        let day = String(new Date().getUTCDate());
        if (day.length == 1) day = '0' + day;

        let hours = String(new Date().getUTCHours());
        if (hours.length == 1) hours = '0' + hours;

        let minutes = String(new Date().getUTCMinutes());
        if (minutes.length == 1) minutes = '0' + minutes;

        return year + month + day + '_' + hours + minutes;
    }
    //////////////////////////////////////////////////////////////////

    public getAffiliateEncryptedToken = (orderID, email, callback) => {
        this.getAffiliateOrderID(orderID, email, callback);
    };

    //////////////////////////////////////////////////////////////////

    public isAffiliateTokenValid = () => {
        let token = StorageUtility.getInstance().getLocal('affiliate');
        if (!token) return;
        token = JSON.parse(token);

        // check expired
        if (this.isTokenExpired()) {
            StorageUtility.getInstance().removeLocal('affiliate');
            return false;
        }

        // check if valid CJ
        if (token && token.affiliate_type === 2 && token.land && token.timestamp && token.cjevent) {
            return true;
        }
        // check if valid PartnerStack
        else if (
            token &&
            token.affiliate_type === 4 &&
            token.land &&
            token.timestamp &&
            token.ps_xid
        ) {
            return true;
        }
        // check if valid Rakuten
        else if (
            token &&
            (token.affiliate_type === 1 ||
                token.affiliate_type === undefined ||
                token.affiliate_type === null) &&
            token.land &&
            token.timestamp &&
            token.ranEAID &&
            token.ranSiteID
        ) {
            return true;
        } else {
            return false;
        }

        // check valid
        return token && token.affiliate_type;
    };

    //////////////////////////////////////////////////////////////////

    public createAffiliateToken = (promo = null) => {
        const params = URLManager.getInstance().getParams();
        let token = {};

        if (
            !params['ranSiteID'] &&
            !params['cjevent'] &&
            !params['irclickid'] &&
            !params['ps_xid']
        ) {
            console.debug(
                '%cNo affiliate cookie created due to missing parameters.',
                'color: grey;'
            );
            return;
        } else if (params['cjevent']) {
            token = {
                affiliate_type: 2,
                cjevent: params['cjevent'],
            };
            URLManager.getInstance().replaceURI(URLManager.getInstance().removeParam('cjevent'));
        } else if (params['ps_xid']) {
            token = {
                affiliate_type: 4,
                ps_partner_key: params['ps_partner_key'],
                ps_xid: params['ps_xid'],
                gsxid: params['gsxid'],
                gspk: params['gspk'],
                source: params['source'],
            };
            URLManager.getInstance().replaceURI(
                URLManager.getInstance().removeParam('ps_partner_key')
            );
            URLManager.getInstance().replaceURI(URLManager.getInstance().removeParam('ps_xid'));
            URLManager.getInstance().replaceURI(URLManager.getInstance().removeParam('gsxid'));
            URLManager.getInstance().replaceURI(URLManager.getInstance().removeParam('gspk'));
            URLManager.getInstance().replaceURI(URLManager.getInstance().removeParam('source'));
        } else if (params['ranSiteID']) {
            token = {
                affiliate_type: 1,
                ranMID: params['ranMID'],
                ranEAID: params['ranEAID'],
                ranSiteID: params['ranSiteID'],
                puboffer: params['puboffer'],
            };
            URLManager.getInstance().replaceURI(URLManager.getInstance().removeParam('ranMID'));
            URLManager.getInstance().replaceURI(URLManager.getInstance().removeParam('ranEAID'));
            URLManager.getInstance().replaceURI(URLManager.getInstance().removeParam('ranSiteID'));
            URLManager.getInstance().replaceURI(URLManager.getInstance().removeParam('puboffer'));
        }

        if (promo) {
            token['promo'] = promo;
        }

        token['land'] = this.rakutenGetTimestamp();
        token['timestamp'] = new Date().getTime();

        StorageUtility.getInstance().setLocal('affiliate', JSON.stringify(token));

        if (!promo) {
            console.debug(
                '%cAffiliate token was successfully created without promo.',
                'color: green;'
            );
        } else {
            console.debug(
                '%cAffiliate token was successfully created with promo: ' + promo,
                'color: green;'
            );
        }
    };

    //////////////////////////////////////////////////////////////////

    public tryAffiliateConversion(
        orderID,
        secondAttempt = false,
        email = null,
        conversionType = 'B2B'
    ) {
        let token = StorageUtility.getInstance().getLocal('affiliate');
        const params = URLManager.getInstance().getParams();

        try {
            token = JSON.parse(token);
        } catch (e) {
            console.error(e);
        }

        // params should not exist at this point since we created cookie
        if (
            params['ranMID'] ||
            params['ranSiteID'] ||
            params['ranEAID'] ||
            params['cjevent'] ||
            params['ps_xid']
        ) {
            console.debug('Affiliate parameters were not tokenized... Fixing...');
            if (!secondAttempt) {
                this.createAffiliateToken();
                this.tryAffiliateConversion(orderID, true, email, conversionType);
                return;
            }
        }

        // make sure token is valid
        if (!this.isAffiliateTokenValid()) {
            console.debug('Affiliate token was invalid.');
            return;
        }

        try {
            const request = {};
            const offerID = token.puboffer ? token.puboffer : 0;
            let typeID = token.affiliate_type;

            if (typeID !== 2 && typeID !== 3 && typeID !== 4) {
                typeID = 1;
            }

            // specific token was already used
            if (this.hasAlreadyTriggeredPixel()) {
                console.debug('Affiliate token has already fired Pixel.');
                return;
            }

            // token doesn't apply to this offer
            if (!this.isB2BTrialOffer(offerID)) {
                return;
            }

            // show that we used the token
            this.makeAffiliateTokenUsed();

            // rakuten data to report
            if (typeID === 1) {
                var theProductName = 'B2B Free Trial';
                var theSKU = 'B2B_FREE_TRIAL';

                if (conversionType === 'B2C') {
                    theProductName = 'B2C Free Trial';
                    theSKU = 'B2C_FREE_TRIAL';
                } else if (conversionType === 'MSP') {
                    theProductName = 'MSP Free Trial';
                    theSKU = 'MSP_FREE_TRIAL';
                } else if (conversionType === 'KCM') {
                    theProductName = 'KCM Free Trial';
                    theSKU = 'KCM_FREE_TRIAL';
                }

                request['affiliate_type'] = typeID;
                request['orderid'] = orderID;
                request['currency'] = 'USD';
                request['conversionType'] = 'sale';
                request['lineitems'] = [
                    {
                        quantity: 1,
                        unitPrice: 0,
                        productName: theProductName,
                        SKU: theSKU,
                    },
                ];
                request['affiliateConfig'] = {
                    ranMID: token.ranMID,
                    land: token.land,
                    tr: token.tr || token.ranSiteID,
                };
                window.keeperPreload.rakutenConversion(request);
                StorageUtility.getInstance().removeLocal('affiliate');
                console.debug('Successfully executed Rakuten affiliate conversion.');
                return;
            }

            // CJ data to report
            if (typeID === 2) {
                request['affiliate_type'] = typeID;
                request['affiliateConfig'] = {
                    CJEventId: token.cjevent,
                };
                request['tag'] = '33369';
                request['cid'] = '1555936';
                request['oid'] = orderID;
                request['type'] = '414668';
                request['currency'] = 'USD';
                request['coupon'] = token.promo ? token.promo : '';
                request['discount'] = '';
                request['cjevent'] = token.cjevent;
                Affiliate.getInstance().cjConversion(request);
                StorageUtility.getInstance().removeLocal('affiliate');
                console.debug('Successfully executed CJ affiliate conversion.');
                return;
            }
        } catch (e) {
            console.error('Error: Failed while executing affiliate conversion.', e);
        }
    }

    //////////////////////////////////////////////////////////////////

    public getAffiliateOrderID = (orderID, email, callback) => {
        let token = StorageUtility.getInstance().getLocal('affiliate');
        token = JSON.parse(token);

        let payload = {};

        // CJ
        if (token.affiliate_type === 2) {
            payload = {
                q: orderID,
                affiliate_email: email,
                affiliate_token: token.cjevent,
                affiliate_date: token.timestamp,
                affiliate_type: 2,
                site_id: token.cjevent,
            };
        }
        // PartnerStack
        else if (token.affiliate_type === 4) {
            payload = {
                q: orderID,
                affiliate_email: email,
                affiliate_token: token.ps_partner_key,
                affiliate_date: token.timestamp,
                affiliate_type: 4,
                affiliate_free_trial: true,
                site_id: token.ps_xid,
            };
            StorageUtility.getInstance().removeLocal('affiliate');
        }
        // Rakuten
        else {
            payload = {
                q: orderID,
                affiliate_email: email,
                affiliate_token: token.ranSiteID,
                affiliate_date: token.timestamp,
                affiliate_type: 1,
                site_id: token.ranEAID,
            };
        }

        try {
            window.keeper.servlets.keeperWeb.checkoutApiWeb('report_affiliate_purchase', payload, {
                success: response => {
                    callback(response);
                },
                error: e => {
                    const response = JSON.parse(e.responseText);
                    if (response.affiliate_quote_id) {
                        callback(response);
                    } else {
                        callback('');
                    }
                },
            });
        } catch (e) {
            console.error(e);
        }
    };

    //////////////////////////////////////////////////////////////////

    public cjConversion = request => {
        try {
            let src = 'https://www.emjcd.com/tags/c';
            src += '?containerTagId=' + request.tag;
            src += '&CID=' + request.cid;
            (src += '&OID=' + request.oid), (src += '&TYPE=' + request.type);
            src += '&CURRENCY=' + request.currency;
            src += '&COUPON=' + request.coupon;
            src += '&DISCOUNT=' + request.discount;
            src += '&CJEVENT=' + request.cjevent;
            src += '&ITEM1=B2B_FREE_TRIAL&AMT1=0&QTY1=1'; // product info

            const img = document.createElement('img');
            img.src = src;
            img.className = 'cj-img';
            document.body.append(img);
        } catch (e) {
            console.error(e);
        }
    };

    //////////////////////////////////////////////////////////////////

    public makeAffiliateTokenUsed = () => {
        let token = StorageUtility.getInstance().getLocal('affiliate');
        token = JSON.parse(token);
        token.leadPixelTriggered = true;
        StorageUtility.getInstance().setLocal('affiliate', JSON.stringify(token));
    };

    //////////////////////////////////////////////////////////////////

    public isTokenExpired = () => {
        let token = StorageUtility.getInstance().getLocal('affiliate');
        if (!token) return;
        token = JSON.parse(token);

        const currDate = new Date();
        currDate.setDate(currDate.getDate() - 90);
        return currDate.getTime() > token.timestamp;
    };
}

export default Affiliate;
